
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/stock-adjustment-types`,
        name: `${prefix}.stock-adjustment-types.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.stock-adjustment-types.index`,
                PageDescription: "Accounts master data: Stock Adjustment Types",
            },
        },
    },
];
